{
  "$schema": "./schema.json",
  "applicationPreview": {
    "heading": "Tarkista ja lähetä",
    "pageTitle": "Hakemuksesi",
    "bidSelected": {
      "subheading": "Hakemuksesi"
    },
    "nonDraft": {
      "heading": "Hakemuksesi"
    },
    "submitCta": "Lähetä hakemus",
    "continueAndReceiveOffersCta": "Jatka ja vastaanota tarjouksia",
    "showOffersCta": "Näytä tarjoukset",
    "backToOffersCta": "Takaisin tarjouksiin",
    "backCta": "Takaisin",
    "mostImportantInformationHeading": "Tärkeimmät tiedot",
    "financialInformation": {
      "heading": "Taloustiedot",
      "subtitle": "Lisää yrityksesi viimeisimmät taloustiedot ja ennusteet"
    },
    "collateralInformation": {
      "heading": "Tietoa vakuuksista",
      "subtitle": "Lisää tietoa mahdollisista vakuuksista"
    },
    "repayment": {
      "heading": "Takaisinmaksu",
      "subtitle": "Määritä lainan takaisinmaksusuunnitelma"
    },
    "additionalFinancingOffers": "Lisää rahoitustarjouksia",
    "additionalFinancingOffersExplainer": "Saadaksesi myös laskurahoitus-, leasing- tai kiinteistölainatarjouksia, täytä alla olevat tiedot.",
    "additionalFinancingOffersQuestionsAnswered": "{{outOf}} kysymystä vastattu",
    "factoringOffersHeading": {
      "title": "Myy myyntilaskusi",
      "subtitle": "Saa rahat heti (jopa 100 % laskun arvosta)"
    },
    "leasingOffersHeading": {
      "title": "Leasing-rahoitus laitteille tai koneille",
      "subtitle": "Yleensä alhaisempi kuukausikustannus"
    },
    "realEstateOffersHeading": {
      "title": "Rahoitus kiinteistövakuudella",
      "subtitle": "Anna vakuudeksi yksityinen tai yrityksesi omistama kiinteistö saadaksesi alhaisemman koron"
    },
    "steps": {
      "nextStep": "Seuraava vaihe",
      "common": {
        "reviewAndSubmit": "Tarkista ja lähetä",
        "creditCheck": "Valmistelemme hakemuksesi",
        "improveApplication": "Analysoimme hakemuksesi varmistaaksemme, että saat parhaat ehdot",
        "receiveFunds": "Valitse paras tarjous ja vastaanota varat"
      }
    },
    "popup": {
      "title": {
        "loading": "Kiitos, melkein valmista...",
        "applicationSent": "Hakemus lähetetty",
        "applicationDigitalAdvice": "Löydät alla parannusehdotukset hakemukseesi.",
        "applicationAdvice": "Yrityksesi on oikeutettu ilmaiseen henkilökohtaiseen neuvontaan.",
        "applicationNotSent": "Hakemusta ei ole vielä lähetetty"
      },
      "preloader": "Analysoimme hakemuksesi ja valmistelemme luottoasiakirjasi"
    },
    "strengthenApplicationHeading": "Paranna hakemustasi",
    "recommended": "Suositeltu",
    "optional": "Valinnainen",
    "required": "Pakollinen",
    "whatHappensNext": {
      "title": "Mitä tapahtuu seuraavaksi?",
      "description": "Luottotiedot tarkistetaan yrityksestäsi ja hakemuksesi lähetetään lainanantajille. Lisätiedot auttavat rahoittajia tekemään parempia tarjouksia luultavammin."
    },
    "companyInformation": "Yritystiedot",
    "companyName": "Yrityksen nimi",
    "organisationNumber": "Y-tunnus",
    "contactDetails": "Yhteystiedot",
    "contactPerson": "Yhteyshenkilö",
    "phoneNumber": "Puhelinnumero",
    "applicationStatus": "Hakemuksen tila",
    "done": "Valmis",
    "fieldsLeft": "{{count}} jäljellä",
    "submit": {
      "title1": "Valmistelemme lainahakemustasi...",
      "title2": "Analysoimme hakemustasi...",
      "titleDone": "Hakemuksesi on analysoitu",
      "continueWithoutImprovements": "Jatka ilman parannuksia",
      "digitalAdvice": {
        "description": "Löysimme {{count}} parannusehdotusta - Niiden lisääminen kestää vain 2-3 minuuttia",
        "descriptionOne": "Löysimme {{count}} parannusehdotusta - Niiden lisääminen kestää vain 2-3 minuuttia",
        "cta": "Näytä parannusehdotukset"
      },
      "revenueAdvice": {
        "description": "Lisäämällä tuoreimman tuloslaskelman, voit saada parempia tarjouksia - Niiden lisääminen kestää vain 2-3 minuuttia",
        "cta": "Lisää tuloslaskelma"
      },
      "manualAdvice": {
        "description": "Voit saada paremmat ehdot käyttämällä neuvontapalveluamme",
        "cta": "Jatka neuvontapalveluun"
      }
    },
    "support": {
      "ctaText": "Kysymyksiä?",
      "previewContactPersonMessage": "<b>Tarvitsetko apua hakemuksesi kanssa?</b><br/>  {{firstName}}, auttaa sinua: <a>{{mobilePhoneNumber}}</a>"
    },
    "showMore": "Näytä lisää",
    "showLess": "Näytä vähemmän"
  }
}
